import React from "react";
import styled, { css } from "styled-components";

import * as colors from "../styles/colors";

const h2Shadow = css`
  text-shadow: 0px 0px 237px rgba(0, 150, 207, 0.5);
`;

const typography = css`
  position: relative;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  z-index: 1;
`;

const headings = {
  h1: css`
    color: ${colors.primaryBright};
    font-size: 88px;
    font-weight: 500;
    line-height: 112%;
    margin: 0;
    transform: translateY(-20px);
    @media (max-width: 768px) {
      background-size: 200px;
      font-size: calc(
        40px + (88 - 60) * ((100vw - 300px) / (700 - 300))
      );
    }
  `,
  h2: css`
    color: ${colors.primaryBright};
    font-size: 46px;
    font-weight: 500;
    margin: 0 0 30px 0;
    ${h2Shadow}

    @media (max-width: 1220px) {
      font-size: 40px;
      margin-bottom: 20px;
    }

    @media (max-width: 1023px) {
      font-size: 35px;
      margin-bottom: 20px;
    }

    @media (max-width: 480px) {
      font-size: 32px;
      margin-bottom: 20px;
    }
  `,
  h3: css`
    color: ${({ color }) => color || colors.light};
    font-size: 32px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -1px;
    margin: 0 0 14px 0;

    @media (max-width: 480px) {
      font-size: 28px;
      margin-bottom: 10px;
    }
  `,
  h4: css`
    color: ${({ color }) => color || "#c7d0d4"};
    font-size: 24px;
    font-weight: 400;
    margin: 0 0 6px 0;
  `,
  h5: css`
    color: ${({ color }) => color || "#3c484e"};
    font-size: 40px;
    margin: 0 0 30px 0;

    @media (max-width: 1023px) {
      font-size: 32px;
      margin-bottom: 20px;
    }

    @media (max-width: 480px) {
      font-size: 28px;
      margin-bottom: 20px;
    }
  `,
  h6: css``
};

const StyledHeading = styled.div`
  ${typography};
  ${({ as }) => as in headings && headings[as]}
`;

export function Heading({ type = "h1", style, children, ...props }) {
  return (
    <StyledHeading as={type} style={style || {}} {...props}>
      {children}
    </StyledHeading>
  );
}
